import { TcNavMenuNodes } from '@tc/core';

export interface MenuState {
  items: TcNavMenuNodes[];
}

export const initialMenuState: MenuState = {
  items: [],
};
